<template>
  <div id="app">
    <search-bar ref="searchBarComponent">
<!--     <div slot="search-tool">
       <el-button class="item-btn el-icon-plus" type="primary" @click="dialogVisible = true">导入</el-button>
       <el-button class="item-btn el-icon-plus" type="primary" @click="downloadDoc">示例文件</el-button>
     </div> -->
      <div slot="search-cont">
        <div class="item" style="width: 20%;">
          <div class="item-label">当前状态</div>
          <el-select v-model="info.status" size="small" slot="prepend" placeholder="请选择当前状态" @change="getTableData">
            <el-option label="在职" value="5"></el-option>
            <el-option label="离职" value="6"></el-option>
          </el-select>
        </div>

        <div class="item" style="width: 25%;" >
          <div class="item-label">	入职时间</div>
          <el-date-picker v-model="info.begintimes" type="daterange" range-separator="-" start-placeholder="入职时间"
            end-placeholder="	入职时间" value-format="yyyy-MM-dd" size="mini" @change="timeChange"></el-date-picker>
        </div>

        <div class="item" style="width: 20%;">
          <div class="item-label">工厂</div>
          <el-select v-model="info.company_id" size="small" slot="prepend" placeholder="请选择工厂" @change="workChange" filterable>
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item,index) in companyList" :key='index' :label="item.companyname" :value="item.id"></el-option>
          </el-select>
        </div>

        <div class="item" >
          <div class="item-label">关键词搜索</div>
          <div style="width: 300px;">
            <el-input placeholder="请输入内容" v-model="info.key" class="input-with-select" size="small"  @keyup.enter.native='searchResume'>
              <el-select v-model="info.key_type" slot="prepend" placeholder="请选择" style="width: 130px" size="small">
                <el-option label="姓名" value="1"></el-option>
                <el-option label="电话号码" value="2"></el-option>
                <el-option label="面试职位" value="4"></el-option>
                <el-option label="录入人" value="5"></el-option>
                <el-option label="招聘专员" value="6"></el-option>
                <el-option label="面试推荐人" value="7"></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-search" @click='searchResume' size="small"></el-button>
            </el-input>
          </div>
        </div>
      </div>
    </search-bar>

    <div class="operation-tool">
      <div @click="dialogVisible = true" class="tool-item"> <img src="../../../static/img/btn/add.png" /> 导入</div>
      <div @click="downloadDoc" class="tool-item"> <img src="../../../static/img/btn/export.png" /> 示例文件</div>
    </div>

    <div class="l-panel">
      <div class="panel-body">
      <el-table class="l-table" :data="tableData" style="width: 100%">
        <el-table-column prop="resume_name" label="姓名" align="center" width="100px"></el-table-column>
        <el-table-column prop="telephone" label="电话" width="180px" align="center"></el-table-column>
        <el-table-column prop="company_name" label="在职工厂" width="180px" align="center"></el-table-column>
        <el-table-column prop="jobs_name" label="在职岗位" width="180px" align="center"></el-table-column>
        <el-table-column prop="entry_time" label="入职时间" width="180px" align="center"></el-table-column>
        <el-table-column prop="leavetime" label="离职时间" width="180px" align="center"></el-table-column>
        <el-table-column prop="idcard" label="身份证" width="180px" align="center"></el-table-column>
        <el-table-column prop="recommendadmin" label="推荐人" align="center"></el-table-column>
        <el-table-column prop="bankcard" label="银行卡" width="180px" align="center"></el-table-column>
        <el-table-column prop="bankname" label="开户行" width="180px" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope='{row}'>
            <span v-if="row.status == 5">在职</span>
            <span v-if="row.status == 6">离职</span>
          </template>
        </el-table-column>
        <el-table-column prop="birthdate" label="年龄" align="center"></el-table-column>
        <el-table-column prop="sex_cn" label="性别" align="center"></el-table-column>
        <el-table-column prop="adminname" label="招聘专员" align="center"></el-table-column>
        <el-table-column prop="wadminname" label="录入人" align="center"></el-table-column>
      </el-table>

    <div class="c-table-pager">
      <el-pagination :current-page="page" :total="total" @current-change='paginationChange'> </el-pagination>
    </div>
    </div>
    </div>

    <el-dialog  title="导入" :visible.sync="dialogVisible" width="65%" class='dialog' v-loading="loading" element-loading-text="上传中...">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="工厂">
          <el-select v-model="form.company_id" placeholder="请选择工厂" @change="getCompanyJobsList">
            <el-option v-for="(item,index) in companyList" :key='index' :label="item.companyname" :value="item.id + ''"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="岗位">
          <el-select v-model="form.jobs_id" placeholder="请选择岗位" @change="selectJobs">
            <el-option v-for="(item,index) in jobsList" :key='index' :label="item.jobs_name" :value="item.id + ''"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="班次类型">
          <el-select v-model="form.work_shift_type" placeholder="请选择班次类型">
            <el-option label="白班" value="1"></el-option>
            <el-option label="晚班" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="工价">
          <el-input v-model="form.price" type="number">
            <template slot="append">（元/小时）</template>
          </el-input>
        </el-form-item>
      </el-form>

      <el-upload class="upload-demo" drag :headers="myHeaders" :before-upload='beforeUpload' :on-progress='onUpload' :on-error='errorUpload' :file-list="fileList"
      name='dailyworker' :on-success='successUpload' :action="baseURL + 'worker/dailyWorkerImport'" multiple :data='this.form'>
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>

    </el-dialog>

  </div>
</template>

<script>
  import Message from '@/utils/message.js';

  export default {
    data() {
      return {
        info: {
          status:'',
          key_type: '',
          key: '',
          operatetype: '',
          type: '',
          endtime: '',
          begintimes:[]
        },
        form:{

        },
        tableData: [],
        total: 1,
        companyList:[],
        jobsList:[],
        dialogVisible:false,
        myHeaders:{},
        loading:false,
        fileList:[]
      }
    },

    mounted() {
      this.getTableData()
      this.gets('oasystem/catecompanylist').then(res => {
        this.companyList = res.data.data
      })
      let token = this.$store.state.token;
      let token_type = this.$store.state.token_type;
      this.myHeaders = {
        authorization: token_type + " " + token,
      };
    },

    methods: {
      timeChange(val) {
        if(val){
          this.info.begintime = val[0] ? val[0] : ''
          this.info.endtime =  val[1] ? val[1] : ''
        }else{
          this.info.begintime =  ''
          this.info.endtime =  ''
        }
        this.info.page = 1
        this.getTableData()
      },

      searchResume() {
        if(!this.info.key_type){return Message.warning('请选择搜索类型')}
        this.info.page = 1
        this.getTableData()
      },

      paginationChange(val) {
        this.info.page = val
        this.getTableData()
      },

      workChange(val) {
        this.info.company_id = val
        this.info.page = 1
        this.getTableData()
      },


      getTableData() {
        this.gets('oasystem/dailyWorkerList', this.info).then(res => {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        })
      },

      getCompanyJobsList(id){
        this.form.jobs_id = ''
        this.form.jobs_name = ''
        this.companyList.map((item)=>{
          if(item.id == id){
            this.form.company_name = item.companyname
          }
        })
        this.gets('category/jobslist?company_id=' + id)
        .then(res=>{
          this.jobsList = res.data.data
        })
      },

      selectJobs(id){
        this.jobsList.map((item)=>{
          if(item.id == id){
            this.form.jobs_name = item.jobs_name
          }
        })
       this.$forceUpdate()
      },

      errorUpload(){
        this.loading = false
        Message.warning('上传失败，请联系管理员')
      },

      beforeUpload(){
        let form = this.form
        let message = !form.company_id ? '请选择工厂' : !form. work_shift_type ? '请选择班次类型' : !form.price ? '请填写工价' : ''
        message? Message.warning(message) : ''
        return message ? false : true
      },

      successUpload(e){
        this.loading = false
        this.fileList = []
        this.form = {}
       if(e.code == 1){
         this.info.page = 1
         this.getTableData()
         this.dialogVisible = false
         Message.success(e.msg)
       }else{
          Message.warning(e.msg)
       }
      },

      onUpload(){
        this.loading = true
      },

      downloadDoc(){
        window.open('http://hyimages.bczphr.com/app/dailyworker/sl.xlsx')
      },
    }
  }
</script>

<style scoped>
  .totalNumber {
    height: 50px;
    padding: 0 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .pagination {
    text-align: center;
    width: 100%;
    background: #fff;
    height: 50px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .table {
    margin: 20px 0;
    background: #fff;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .content {
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .dialog >>> .upload-demo{
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/view/oasystem/dailyWorkerList.vue